import React from "react";
import { motion } from "framer-motion";
import { UploadCloud, ScanSearch, ShieldCheck } from "lucide-react";
import { StaggerGroup, staggerItem, MaskReveal } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    icon: UploadCloud,
    title: "Give it to Dox",
    desc: "Drop in licenses, permits, insurance, bonds — or snap a photo. Hand it over once. No forms to fill out. You walk away.",
  },
  {
    num: "02",
    icon: ScanSearch,
    title: "DOX reviews & organizes",
    desc: "DOX reads each document, categorizes it, extracts deadlines and explains it in plain English — with confidence and sources.",
  },
  {
    num: "03",
    icon: ShieldCheck,
    title: "Stay compliant, automatically",
    desc: "DOX monitors renewals, prepares paperwork and alerts you before anything lapses. Your compliance runs on autopilot.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="relative py-28 sm:py-40 dash-stage border-y border-white/5">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-16 sm:mb-20">
          <div className="text-xs font-bold tracking-[0.25em] uppercase text-dox-orange mb-5">How It Works</div>
          <h2 className="font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-[3.5rem] leading-[1.02]">
            <MaskReveal>Three steps.</MaskReveal>
            &nbsp;
            <MaskReveal delay={0.15}><span className="text-gradient-brand">Then you&rsquo;re free.</span></MaskReveal>
          </h2>
        </div>

        <StaggerGroup className="grid md:grid-cols-3 gap-6">
          {CHAPTERS.map((c) => (
            <motion.div
              key={c.num}
              variants={staggerItem}
              className="group relative glass-card p-9 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="font-display font-black text-7xl leading-none text-white/[0.06] group-hover:text-dox-orange/20 transition-colors">
                {c.num}
              </div>
              <div className="-mt-6 relative">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-dox-orange to-dox-magenta text-white mb-5 shadow-[0_0_28px_rgba(255,0,127,0.35)]">
                  <c.icon size={22} />
                </div>
                <h3 className="font-display font-bold text-2xl text-white mb-3 tracking-tight">{c.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{c.desc}</p>
              </div>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
